/* tslint:disable */
/* eslint-disable */
/**
 * AddressCheckPublic API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import type { IsoCountryCodeEnum } from './IsoCountryCodeEnum';
import {
  IsoCountryCodeEnumFromJSON,
  IsoCountryCodeEnumToJSON,
} from './IsoCountryCodeEnum';

/**
 *
 * @export
 * @interface UpdateSchoolDataDto
 */
export interface UpdateSchoolDataDto {
  /**
   *
   * @type {IsoCountryCodeEnum}
   * @memberof UpdateSchoolDataDto
   */
  country: IsoCountryCodeEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateSchoolDataDto
   */
  postalCode: string;
  /**
   *
   * @type {string}
   * @memberof UpdateSchoolDataDto
   */
  city: string;
  /**
   *
   * @type {string}
   * @memberof UpdateSchoolDataDto
   */
  street: string;
  /**
   *
   * @type {string}
   * @memberof UpdateSchoolDataDto
   */
  streetNumber: string;
  /**
   *
   * @type {string}
   * @memberof UpdateSchoolDataDto
   */
  streetAddition?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateSchoolDataDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof UpdateSchoolDataDto
   */
  phone: string;
  /**
   *
   * @type {string}
   * @memberof UpdateSchoolDataDto
   */
  homepage?: string | null;
}

/**
 * Check if a given object implements the UpdateSchoolDataDto interface.
 */
export function instanceOfUpdateSchoolDataDto(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && 'country' in value;
  isInstance = isInstance && 'postalCode' in value;
  isInstance = isInstance && 'city' in value;
  isInstance = isInstance && 'street' in value;
  isInstance = isInstance && 'streetNumber' in value;
  isInstance = isInstance && 'email' in value;
  isInstance = isInstance && 'phone' in value;

  return isInstance;
}

export function UpdateSchoolDataDtoFromJSON(json: any): UpdateSchoolDataDto {
  return UpdateSchoolDataDtoFromJSONTyped(json, false);
}

export function UpdateSchoolDataDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateSchoolDataDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    country: IsoCountryCodeEnumFromJSON(json['country']),
    postalCode: json['postalCode'],
    city: json['city'],
    street: json['street'],
    streetNumber: json['streetNumber'],
    streetAddition: !exists(json, 'streetAddition')
      ? undefined
      : json['streetAddition'],
    email: json['email'],
    phone: json['phone'],
    homepage: !exists(json, 'homepage') ? undefined : json['homepage'],
  };
}

export function UpdateSchoolDataDtoToJSON(
  value?: UpdateSchoolDataDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    country: IsoCountryCodeEnumToJSON(value.country),
    postalCode: value.postalCode,
    city: value.city,
    street: value.street,
    streetNumber: value.streetNumber,
    streetAddition: value.streetAddition,
    email: value.email,
    phone: value.phone,
    homepage: value.homepage,
  };
}
